import { Link } from "react-router-dom";
import { PHONE } from "@/mocks/updiag";

export default function CtaFinal() {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/img/readdy/cta1.jpg"
          alt="Diagnostic immobilier Paris"
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#F97316]/90 to-orange-700/85"></div>
      </div>
      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-5 leading-tight" style={{ fontFamily: "Barlow, sans-serif" }}>
          Prêt à obtenir votre diagnostic ?
        </h2>
        <p className="text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Devis gratuit en 2 minutes, intervention sous 48h dans toute l'Île-de-France. Rapport certifié le jour même.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
          <Link
            to="/devis"
            className="flex items-center justify-center gap-2 px-8 py-4 bg-white text-[#F97316] rounded-xl font-bold text-base hover:bg-gray-50 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-file-list-3-line"></i>
            Obtenir mon devis gratuit
          </Link>
          <a
            href={`tel:${PHONE.replace(/\s/g, "")}`}
            className="flex items-center justify-center gap-2 px-8 py-4 border-2 border-white text-white rounded-xl font-bold text-base hover:bg-white/10 transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-phone-fill"></i>
            Appeler maintenant
          </a>
        </div>
        <p className="text-white/70 text-sm flex items-center justify-center gap-2">
          <i className="ri-time-line"></i>
          Réponse sous 2h — Aucun engagement — Devis 100% gratuit
        </p>
      </div>
    </section>
  );
}
